const startSigning = async documentId => {
  const signRedirect = await fetch(`/api/scrive/startsigning/${documentId}`, {
    method: 'POST',
  }).then(res => res.json())

  return signRedirect
}

export default startSigning
